import { Controller } from "@hotwired/stimulus"

// Sign-up "I am joining as a..." patient/surgeon picker. Was relying on Tailwind's
// has-[:checked] variant, which needs Tailwind 3.4+ — this project pins 3.3.5, so
// the selected-state styling silently never rendered. Toggling the classes in JS
// instead so it works regardless of Tailwind version.
export default class extends Controller {
  static targets = ["option"]

  connect() {
    this.sync()
  }

  pick() {
    this.sync()
  }

  sync() {
    this.optionTargets.forEach((label) => {
      const input = label.querySelector("input[type=radio]")
      label.classList.toggle("border-blue-600", input.checked)
      label.classList.toggle("bg-blue-50", input.checked)
    })
  }
}
